<template>
  <div class="ui-switch-container">
    <div class="ui-switch" :class="classList" @click="toggleValue">
      <div
        v-if="!loading"
        class="ui-switch__slider"
        :class="classList"
        :style="backgroundColor"
      >
        <div class="ui-switch__slider--switch"></div>
      </div>
      <ui-skeleton
        class="ui-switch__slider"
        v-else
      />
      <div v-if="hasTitle" class="ui-switch__title">
        <slot>
          <template v-if="title">
            {{ title }}
          </template>
          <template v-else>
            {{ valueTitle }}
          </template>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import checkboxMixin from '../../mixins/checkboxMixin'
import UiSkeleton from '../skeleton/UiSkeleton.vue'

export default {
  components: { UiSkeleton },
  mixins: [checkboxMixin]
}
</script>

<style lang="scss" scoped>
.ui-switch-container {
  display: inline-flex;
  align-items: center;
}

.ui-switch {
  display: flex;
  align-items: center;
  user-select: none;
  cursor: pointer;

  &.container-size {
    &-small {
      min-height: 40px;
    }

    &-medium {
      min-height: 54px;
    }
  }

  &.disabled {
    color: $gray-4;
    cursor: auto;
  }

  &.error {
    color: $red;
  }

  &__slider {
    $slider: &;
    $size: 16px;
    $sliderMargin: 2px;

    position: relative;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    height: 18px;
    width: $size*2;
    border-radius: 100px;
    background-color: $gray-4;
    transition: background-color .2s;
    cursor: pointer;

    &--switch {
      position: absolute;
      left: $sliderMargin;
      height: $size - $sliderMargin;
      width: $size - $sliderMargin;
      background-color: $light-01;
      border-radius: 50%;
      transition: background-color .2s, left .2s;
    }

    &.active {
      background-color: $primary;

      #{$slider}--switch {
        left: $size;
      }
    }

    &.disabled {
      opacity: .6;
      cursor: auto;

      &.error {
        #{$slider}--switch {
          background-color: $light-01;
        }
      }
    }

    &.error {
      background-color: $red;
    }
  }

  &__title {
    margin-left: 10px;
  }
}
</style>
